import { PageSizeSelectItem } from "../components/paging/PageSizeSelectItem";
import { SearchFilterItem } from "../components/search/SearchFilterItem";

export const pageSizeValues: PageSizeSelectItem[] = [
    {
        value: 20
    },
    {
        value: 50
    },
    {
        value: 100
    },
]

export const sentApplicationsSearchFilters: SearchFilterItem[] = [
    {
        filterName: "requesteeCustomerNumbers",
        filterLabel: "Customer number"
    },
    {
        filterName: "requesteeUsernames",
        filterLabel: "Receiver username"
    },
    {
        filterName: "receivedStartDate",
        filterLabel: "Created after"
    },
    {
        filterName: "receivedEndDate",
        filterLabel: "Created before"
    },
]
export const receivedApplicationSearchFilters: SearchFilterItem[] = [
    {
        filterName: "requesteeCustomerNumbers",
        filterLabel: "Customer number"
    },
    {
        filterName: "requestorUsernames",
        filterLabel: "Applicant username"
    }
]
export const customerAuthorizationsSearchFilters: SearchFilterItem[] = [
    {
        filterName: "customerNumbers",
        filterLabel: "Customer number"
    },
]
export const authorizedUsersSearchFilters: SearchFilterItem[] = [
    {
        filterName: "usernames",
        filterLabel: "Username"
    },
]

export const organizationSearchFilters: SearchFilterItem[] = [
    {
        filterName: "names",
        filterLabel: "Organization"
    },
]